<form autocomplete="off" [formGroup]="form" (ngSubmit)="validateForm()">
    <h4>Detalle de la encuesta: </h4>
    <hr>
    <div class="col-12">
        <div class="form-group row">
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Nombre</label>
                <input class="form-control form-input" type="text" placeholder="Nombre" formControlName="name"
                    autocomplete="off" [class.is-invalid]="campoNoValido('name')">
                <small class="text-danger" *ngIf="campoNoValido('name')">Este campo es requerido</small>
            </div>
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Título de la encuesta</label>
                <input class="form-control form-input" type="text" placeholder="Título" formControlName="title"
                    autocomplete="off" [class.is-invalid]="campoNoValido('title')">
                <small class="text-danger" *ngIf="campoNoValido('title')">Este campo es requerido</small>
            </div>
            <div class="textOnInput col-sm-12 col-md-6">
                <label class="form-label" for="inputText">Fecha de inicio</label>
                <input class="form-control form-input" type="date" formControlName="startdate" autocomplete="off">
            </div>
            <div class="textOnInput col-sm-12 col-md-6">
                <label class="form-label" for="inputText">Fecha de finalización</label>
                <input class="form-control form-input" type="date" formControlName="enddate" autocomplete="off">
            </div>
            <div class="textOnInput col-sm-12 col-md-4">
                <label class="form-label" for="inputText">Estado</label>
                <select class="form-control form-input" name="" formControlName="idstatus">
                    <option class="form-control" [ngValue]="null">Seleccione un estado</option>
                    <option *ngFor="let s of status" value="{{s.id}}">
                        {{s.label}}
                    </option>
                </select>
            </div>
            <div class="textOnInput col-sm-12 col-md-4">
                <label class="form-label" for="inputText">Fecha de creación</label>
                <div class="form-control form-input" disabled>{{form.get('createdAt').value | date:'short'}}</div>
            </div>
            <div class="textOnInput col-sm-12 col-md-4">
                <label class="form-label" for="inputText">Fecha de actualzación</label>
                <div class="form-control form-input" disabled>{{form.get('updatedAt').value | date:'short'}}</div>
            </div>
            <div class="textOnInput col-sm-12 col-md-6">
                <label class="form-label" for="inputText">Imágen o logo</label>
                <input class="form-control form-input" type="text" formControlName="logo">
            </div>
            <div class="textOnInput col-sm-12 col-md-6">
                <form action="" method="post" enctype="multipart/form-data">
                    <input type="file" id="input-file" (change)="onFileChange($event)" accept="image/png, .jpg">
                </form>
            </div>
            <div class="textOnInput col-sm-12 col-md-6">
                <label class="form-label" for="inputText">Url</label>
                <input class="form-control form-input" type="text" formControlName="url">
            </div>
            <div class="textOnInput col-12 text-center">
                <ng-container *ngIf="form.get('logo').value != null">
                    <ng-container *ngIf="isUploadDir">
                        <img class="img-fluid" src="{{URL}}{{form.get('logo').value}}" alt="" style="height: 150px;">
                    </ng-container>
                    <ng-container *ngIf="!isUploadDir">
                        <img class="img-fluid" src="{{form.get('logo').value}}" alt="" style="height: 150px;">
                    </ng-container>
                </ng-container>
            </div>

        </div>
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-start">
                    <div class="me-2">
                        <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                            Cancelar
                        </button>
                    </div>
                    <div class="col-6 input-group">
                        <button type="submit" class="btn btn-outline-primary btn-block">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!hiddenMsg">
        <app-alert [message]="msg.message" [status]="msg.status"></app-alert>
    </ng-container>

</form>